<!-- 代码编程模式的右侧markdown文档显示页面，限制编辑-->
<template>
  <div class="markdown-doc-content" v-show="show">
    <div class="header-wrap">
      <span class="label">Python+AI模型</span>
      <i class="icon-close" title="关闭" @click="cancelHandle">
        <icon-base
          :icon-name="Icons.PopupClose.iconName"
          v-bind="Icons.PopupClose"
        >
          <icon-popup-close
            class="path-icon-close"
            :icon-name="Icons.PopupClose.iconName"
            v-bind="Icons.PopupClose"
          />
        </icon-base>
      </i>
    </div>
    <!-- <iframe src="/editor/md" class="markdown-editor-iframe"> -->
    <editor-md :value="document"></editor-md>
    <!-- </iframe> -->
  </div>
</template>

<script>
import IconPopupClose from '@/components/icons/typography/PopupClose'
export default {
  name: 'MarkdownDoc',
  components: { IconPopupClose },
  props: {
    document: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      Icons: {
        PopupClose: {
          iconName: '关闭',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"
        },
      },
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 取消位置的按钮
    cancelHandle() {
      this.$emit('showHandler', false)
    },
    // stopEvent() {},
  },

  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  destroyed() {},
}
</script>
<style lang="scss" scoped>
.markdown-doc-content {
  width: $run_area_width;
  height: 100%;
  position: fixed;
  // position: fixed;
  z-index: 10;
  right: 0;
  margin-top: 0px;
  border-left: 2px solid rgba(74, 224, 226, 0.1);
  .header-wrap {
    position: absolute;
    z-index: 2;
    // background: #15234c !important;
    background: rgba(103, 140, 255, 0.3);
    padding: 6px 0;
    font-size: 14px;
    width: 100%;
    padding: 10 10px;
    display: flex;
    justify-content: space-between;
    > .label {
      margin-left: 10px;
    }
    .icon-close {
      // margin-right: 10px;
      cursor: pointer;
      transform: scale(0.8);
      position: fixed;
      right: 10px;

      &:hover::v-deep .path-icon-close {
        fill: #4c88ff;
      }
    }
  }
  .markdown-editor-iframe {
    width: 100%;
    height: 100%;
    //  position: relative;
  }

  /deep/ .markedown-document-content {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(94, 147, 255, 0.1) !important;
    // margin-top:20px;
    .markdown-body {
      height: 100%;
      margin: 40px 0 0 0;
      blockquote {
        // color:rgba(251,251,251,0.7) !important;
        color: #d0dcff !important;
        font-size: 14px;
        border-left: none;
      }
      p,
      ul {
        color: #d0dcff !important;
      }
      a {
        // color: rgba(254, 254, 255,.6);
        color: rgba(153, 178, 255, 0.6);
        font-family: 'MicrosoftYaHei';
        font-size: 13px;
      }
      table {
        color: #333;
        background: #fff;
        @include scroll-bar(5px, 1px);
      }
      h2 {
        display: block;
        border-bottom: 1px solid #253a76;
        padding-bottom: 10px;
        font-size: 1.2em;
        a {
          padding-top: 12px;
          display: block;
        }
      }
      h3 {
        color: #7084c3;
        font-size: 16px;
      }
      pre {
        // background: rgba(255, 255, 255, 0.5);
        @include scroll-bar(5px, 1px);
      }
      .hljs {
        // background: rgba(255, 255, 255, 0);
        @include scroll-bar(5px, 1px);
      }
    }
    // .v-note-panel {
    // //  padding-top:10px;
    //   // .v-note-edit {
    //   //   /* 设置滚动条的样式 */
    //   //   // @include scroll-bar(5px, 1px); 
    //   // }
    // }

    .v-note-show {
      color: #fefeff !important;
      // color:rgba(251,251,251,0.7) !important;
      // background: #15234c !important;
      .v-show-content {
        // background: #15234c !important;
        height: 92%;
        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          width: 5px;
          box-shadow: inset006pxrgba(0, 0, 0, 0.7);
          -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
          //  background: #678cff!important;
        }
        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          box-shadow: inset006pxrgba(0, 0, 0, 0.7);
          -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
          border-radius: 1px;
          background-color: #15234c;
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #678cff !important;
          box-shadow: inset006pxrgba(0, 0, 0, 0.7);
          -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
        }
        &::-webkit-scrollbar-thumb:window-inactive {
          background: rgba(103, 140, 255, 0.5);
        }
      }
    }

    .v-note-wrapper {
      background: rgba(94, 147, 255, 0) !important;
      // padding-top:10px !important; 
    }
  }
}

::v-deep.markdown-doc-content .markedown-document-content .v-note-show .v-show-content{
  background: rgba(94, 147, 255, 0) !important;
}
</style>
